import axiosInstance from "../../../helpers/api";

export const getPracticeUsers = (formData) => {
  const page = formData?.payload || 1;
  const name = formData?.name || "";
  return axiosInstance.get(
    `/asquera_practice/users?page=${page}&name=${name}`
  );
};

export const getPracticeSubjects = () => {
  return axiosInstance.get("/asquera_practice/subjects");
};

export const getActiveSubscriptions = (subjectId) => {
  const params = {};
  if (subjectId) {
    params.subject_id = subjectId;
  }
  return axiosInstance.get("/asquera_practice/subscriptions/list_active", {
    params,
  });
};

export const createPracticeSubscription = (payload) => {
  return axiosInstance.post("/asquera_practice/subscriptions", payload);
};

export const sendBulkCustomMessageToPhones = (payload) => {
  const template = Number(payload?.template ?? 0);
  const body = {
    phones: payload?.phones || [],
    template,
  };

  if (template === 1) {
    body.msg_1 = payload?.msg_1 || "";
    body.msg_2 = payload?.msg_2 || "";
    body.msg_3 = payload?.msg_3 || "";
  } else {
    body.message = payload?.message || "";
  }

  return axiosInstance.post(
    "/admin/asquera_practice/send_bulk_custom_message_to_phones",
    body
  );
};
